// extracted by mini-css-extract-plugin
module.exports = {"textArea":"ReportMap_textArea__3Z3On","submit":"ReportMap_submit__1-I_6"};